import { combineReducers } from "redux";
import pickupdrop from "../features/serviceadmin/pickupdrop/Slice";


const serviceadmin = combineReducers({
  pickupdrop: pickupdrop,
});

export default serviceadmin;
